import { NgModule } from '@angular/core';
import { TypingTextComponent } from './typing-text.component';

@NgModule({
    declarations: [
        TypingTextComponent
    ],
    imports: [],
    exports: [
        TypingTextComponent
    ]
})
export class NcTypingTextModule { }